import { WebPushAuthType } from 'modules/webPush/types';

export enum ModalType {
  ConfigureIntegrationModal = 'ConfigureIntegrationModal',
  DeleteIntegrationModal = 'DeleteIntegrationModal',
  TestWebPushModal = 'TestWebPushModal',
}

export type BaseModalProps = {
  onClose: () => void;
};

export type ConfigureIntegrationModalProps = { authType?: WebPushAuthType } & BaseModalProps;

export type TestWebPushModalProps = {
  fileName?: string;
  isTestingLater?: boolean;
} & BaseModalProps;

export type ModalProps = ConfigureIntegrationModalProps | TestWebPushModalProps;

/** Close is handled directly in the provider, provider consumers should not be using onClose */
export type ModalPropsWithoutClose = Omit<ModalProps, 'onClose'>;

export type OpenedModal = {
  modalType: ModalType;
  modalProps?: ModalPropsWithoutClose;
};

export type ModalsContextState = {
  closeModal: (modalType: ModalType) => void;
  openedModals: OpenedModal[];
  openModal: (modalType: ModalType, modalProps?: ModalPropsWithoutClose) => void;
};

export type IntegrationTableRow = {
  type: string;
  serverKey?: JSX.Element;
  actions: JSX.Element;
};
